import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { ShieldWarning } from '@phosphor-icons/react';
import { fetchMyPendingCount } from '@/lib/policiesApi';

/**
 * Dashboard nudge: "N policies require your acceptance" → My Policies.
 * Renders nothing when there's nothing pending.
 */
export function PolicyNudge() {
  const navigate = useNavigate();
  const q = useQuery({ queryKey: ['my-policy-count'], queryFn: fetchMyPendingCount, staleTime: 60_000 });
  const count = q.data ?? 0;
  if (count === 0) return null;
  return (
    <button
      onClick={() => navigate('/me/policies')}
      className="mb-4 flex w-full items-center justify-between gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-left transition hover:bg-amber-100 dark:border-amber-500/40 dark:bg-amber-500/10 dark:hover:bg-amber-500/20"
    >
      <div className="flex items-center gap-2 text-sm text-amber-900 dark:text-amber-200">
        <ShieldWarning className="h-5 w-5 shrink-0" />
        <span>
          <strong>{count} {count === 1 ? 'policy' : 'policies'}</strong> require your acceptance
        </span>
      </div>
      <span className="text-xs font-medium text-amber-800 dark:text-amber-300">Review →</span>
    </button>
  );
}
